import React from 'react';
import { Reveal } from './Reveal';
const stats = [['10', 'Komplette Bände'], ['600', 'Seiten Curriculum'], ['80', 'Unterrichtseinheiten'], ['100%', 'Für alle Bundesländer']];
export function StatsBar() {
  return <section className="border-y border-brand-line bg-brand-alt py-9" data-id="element-148" data-mp="1oa3spnnah9qo">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-149" data-mp="1jcu0k08imjz5">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-line' : ''}`} data-id="element-150" data-mp="1ef2731s82psu" data-mpi={index}>
            <span className="mb-1 font-display text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-151" data-mp="15lfgrr6saer1">
              {value}
            </span>
            <span className="text-[10px] font-bold uppercase tracking-[0.12em] text-brand-gray md:text-xs" data-id="element-152" data-mp="vmgf4skfrjdj">
              {label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}